/**
 * 打开url-新的tab
 * @param url
 */
export function previewUrl(url) {
  if (!document.getElementById("previewA")){
    let a = document.createElement('a');
    a.setAttribute('target', '_blank');
    a.setAttribute('id', 'previewA');
    document.body.appendChild(a);
  }
  document.getElementById("previewA").setAttribute("href", url);
  document.getElementById("previewA").click();
}
/**
 * form形式下载文件
 * @param url
 * @param param
 */
export function downloadUseForm(url, param) {
  let form = document.createElement('form')
  form.action = url
  form.method = 'post'
  form.style.display = 'none'
  for (let item in param) {
    let input = document.createElement('input')
    input.type = 'hidden'
    input.name = item
    input.value = param[item]
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}
export function downloadUseA(url) {
  if (!document.getElementById("downloadA")){
    let a = document.createElement('a');
    a.setAttribute('target', '_blank');
    a.setAttribute('id', 'downloadA');
    document.body.appendChild(a);
  }
  document.getElementById("downloadA").setAttribute("href", url);
  document.getElementById("downloadA").click();
}
/**
 * 格式化文件大小
 * @param value
 * @returns {string}
 */
export function formatFileSize(value, fixedNumber) {
  if(null==value||value==''){
    return "0B";
  }
  let unitArr = new Array("B","KB","MB","GB","TB","PB","EB","ZB","YB");
  let index=0, srcsize = parseFloat(value);
  index=Math.floor(Math.log(srcsize)/Math.log(1024));
  let size =srcsize/Math.pow(1024,index);
  if(typeof (fixedNumber) == "undefined" || fixedNumber == null || fixedNumber < 0) {
    fixedNumber = 2;
  }
  size=size.toFixed(fixedNumber);  //  保留的小数位数
  let fileSizeStr = ''+size;
  try {
    if(size > 0) {
      fileSizeStr = fileSizeStr.replace(/[.]?0+$/,"")
    }
  } catch (e) {
    console.error(e, new Date())
  }
  return fileSizeStr + unitArr[index];
}

/**
 * 获取二级类型
 * @param attachFileName
 * @returns {string|*}
 */
export function  getFileType(fileName) {
  let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
  let type = suffix.toUpperCase();
  let fileType = SC_FILE.fileType[type];
  if(fileType >= 0 && fileType < 8){
    return SC_FILE.fileTypeName[fileType];
  }
  if(typeof(fileType) == "undefined"){
    return "url";
  }
  return "";
}
/**
 * 获取一级类型
 * @param fileName
 * @returns {string}
 */
export function  getFirstFileType(fileName){
  let secondFileType = getFileType(fileName);
  // 一级文件类型
  let firstFileType = '';
  let tempMap = SC_FILE.firstType;
  for (let key in tempMap){
    if (tempMap[key].indexOf(secondFileType) > -1){
      firstFileType = key;
    }
  }
  return firstFileType;
}

/**
 * 校验文件是否超过限制大小
 * @param fileName
 * @param fileSize
 * @returns {boolean}
 */
export function validateSize(fileName, fileSize){
  // 二级文件类型
  let secondFileType = getFileType(fileName);
  // 一级文件类型
  let firstFileType = '';
  let tempMap = SC_FILE.firstType;
  for (let key in tempMap){
    if (tempMap[key].indexOf(secondFileType) > -1){
      firstFileType = key;
      break;
    }
  }
  let $fileInfo = SC_FILE.typeInfo[firstFileType];
  if (fileSize > $fileInfo.maxSize){
    return $fileInfo.info;
  }
  return "success";
}
let SC_FILE = {
  fileType:{
    'PPT' : '0',
    'PPTX' : '0',
    'DOC' : '1',
    'DOCX' : '1',
    'PDF' : '2',
    'PNG' : '3',
    'JPEG' : '3',
    'JPG' : '3',
    'WMV' : '4',
    'AVI' : '4',
    'RM' : '4',
    'RMVB' : '4',
    'DAT' : '4',
    'ASF' : '4',
    'RAM' : '4',
    'MPG' : '4',
    'MPEG' : '4',
    '3GP' : '4',
    'MOV' : '4',
    'MP4' : '4',
    'M4V' : '4',
    'DVIX' : '4',
    'DV' : '4',
    'F4V' : '4',
    'MKV' : '4',
    'FLV' : '4',
    'VOB' : '4',
    'QT' : '4',
    'CPK' : '4',
    'MP3' : '5',
    'WAV' : '5',
    'TXT' : '6',
    'XLSX' : '7',
    'XLSM' : '7',
    'XLTX' : '7',
    'XLTM' : '7',
    'XLS' : '7'
  },
  // 二级类型
  fileTypeName : {
    0 : 'ppt',
    1 : 'word',
    2 : 'pdf',
    3 : 'image',
    4 : 'video',
    5 : 'audio',
    6 : 'text',
    7 : 'excel'
  },
  // 总类型（一级类型）
  firstType : {
    word : "ppt, word, pdf, text, excel",
    image : 'image',
    audio : 'audio',
    video : "video",
  },
  // 一级类型提示信息
  typeInfo : {
    image : {
      maxSize : 50 * 1024 * 1024,
      info : '上传图片不能超过50M',// '上传图片不能超过50M'
    },
    word : {
      maxSize : 200 * 1024 * 1024,
      info : '上传文档文件不能超过200M', // '上传文档文件不能超过200M',
    },
    audio : {
      maxSize : 50 * 1024 * 1024,
      info : '上传音频不能超过50M', // '上传音频不能超过50M',
    },
    video : {
      maxSize : 1024 * 1024 * 1024,
      info : '上传视频不能超过1GB', // '上传视频不能超过1GB',
    }
  }
}

//验证上传文件的文件名是否合法
export function validateFileName(fileName ){
  let reg = new RegExp("[\\\\/:*?\"<>|]")
  if (reg.test(fileName)) {
    // "上传的文件名不能包含【\n / \\ ： * ？ < > |】这些非法字符,请修改后重新上传!";
    return false;
  }
  return true;
}

export function fmtInvalidFileName(fileName ) {
  try {
    if(fileName != '') {
     return fileName.replaceAll(/[\\\\/:*?\\"<>|]/g, '')
    }
  } catch (e) {
    console.error(e)
  }
  return fileName;
}